export default __webpack_public_path__ + "static/media/96b3a113-3e18-46f9-b6e3-5bdee7288b20.9598cf84.woff";